import React, { useState } from 'react';
import { Button, Card, Col, InputGroup, Row } from 'react-bootstrap';
import { BsList } from 'react-icons/bs';
import { IoMdAddCircleOutline } from 'react-icons/io';
import { IoAddCircleOutline } from 'react-icons/io5';
import { MdFavorite, MdFavoriteBorder, MdOutlineAddShoppingCart, MdOutlinePageview } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const ProductCardSearch = ({ product, onAddToCart, onAddToFavorites }) => {

  const navigate = useNavigate();

  const handleDetailClick = (row) => {
    // navigate('/detail-product', {
    //   state: { row }
    // })
    Swal.fire({
      title: 'Loading Product Details...',
      text: 'Please wait while we fetch the product details.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    // Simulate delay (optional, remove if unnecessary)
    setTimeout(() => {
      Swal.close(); // Close loading popup
      navigate('/detail-product', { state: { row } });
    }, 1000); // Adjust time as needed (1s delay)
  };

  const [hover, setHover] = useState(false);

  return (
    <Card
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        cursor: 'pointer',
        border: "none",
        padding: 0,
        margin: 0,
        overflow: "hidden",
        border: hover ? '3px solid green' : 'none',
        padding: 0,
        margin: 0,
        overflow: 'hidden',
        transition: 'border 1.5s ease'
      }}>
      <Card.Img
        variant="top"
        src={product.image ? product.image : 'default_480x320.png'}
        alt={product.name}
        style={{ height: "90px", objectFit: "cover" }}
      />
      <Card.Header className="bg-white"
        style={{
          borderBottom: "2px solid #ddd", // Underline
          fontSize: 12,
          maxHeight: "30px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap"
        }}>
        {product.name}
      </Card.Header>
      <Card.Body style={{ maxHeight: "170px", overflow: "hidden" }}>
        <Card.Text style={{
          fontSize: 10,
          maxHeight: "15px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 0, // Set max number of lines before truncation
        }}>{product.alias_name}</Card.Text>
        <Card.Text style={{
          fontSize: 10,
          maxHeight: "15px",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: 0, // Set max number of lines before truncation
        }}>
          Rp.,{product.starting_price}
        </Card.Text>
        {/* InputGroup with Buttons */}
        <InputGroup size='sm' className="d-flex flex-wrap m-0 p-0">
          <Button
            variant="outline-success"
            onClick={() => onAddToFavorites(product.id)}
            className="flex-grow-1 mb-1"
          >
            <MdFavoriteBorder size={15} />
          </Button>

          <Button
            variant="success"
            className="flex-grow-1 mb-1"
            onClick={() => onAddToCart(product.id)}
          >
            <MdOutlineAddShoppingCart size={15} />
          </Button>
        </InputGroup>
        <InputGroup size='sm' className="d-flex flex-wrap">
          <Button
            variant="outline-success"
            className="flex-grow-1 mb-1"
            onClick={() => handleDetailClick(product)}
          >
            {/* <BsList size={17} /> */} <span style={{ fontSize: 13 }}>Lihat Detail</span>
          </Button>
        </InputGroup>
      </Card.Body>
    </Card>
  );
};

export default ProductCardSearch;
